import React from 'react';
import { BrowserRouter as Router, Routes, Route, useNavigate, useLocation } from 'react-router-dom';
import Sidebar from './components/Sidebar/Sidebar';
import HomePage from './components/HomePage/HomePage';
import ContactPage from './components/ContactPage/ContactPage';
import BookingPage from './components/BookingPage/BookingPage';
import BookingForm from './components/BookingForm/BookingForm';
import DoctorBookingPage from './components/DoctorBook/DoctorBook';
import BlogsPage from './components/Blogs/BlogsPage';
import './App.css';

const AppLayout = () => {
  const location = useLocation();
  const isActive = () => {
    const path = location.pathname;
    return {
      height: path.includes('book') ? '100%' : '100dvh'
    };
  };
  return (
    <div className="app">
      <Sidebar />
      <div className="main-content" >
        <div className='main-card'>
  <Routes>
          <Route path="/" element={<BookingPage />} />
          <Route path="/home" element={<HomePage />} />
          <Route path="/booking-form" element={<BookingForm />} />
          <Route path="/doctor-booking" element={<DoctorBookingPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/blogs" element={<BlogsPage/>} />
        </Routes>
  </div>        
      </div>
    </div>
  );
};

const PrediMindWebsite = () => (
  <Router>
    <AppLayout />
  </Router>
);

export default PrediMindWebsite;